const pathNameServiceTypeMapping = {
    'activities': 6,
    'staycations': 4,
    'buses': 7,
    'holidays': 8
};

export { pathNameServiceTypeMapping };